'use strict';
/* jshint ignore:start */
var storefront = {

	socialButtonsEvent: function (e) {
		var obj = {
			'event': 'socialButtons',
			'button_ID': e.currentTarget.className ? e.currentTarget.className : '',
			'outbound_link_name': $(e.currentTarget).attr('href'),
			'outbound_link_site': $(e.currentTarget).attr('class')
		};
		dataLayer.push(obj);
	},

	pageLoadEvent: function () {
		if ($('input[name=pageLoadData]').length > 0) {
			var pageLoad = JSON.parse($('input[name=pageLoadData]').val());
		}
		if ($('input[name=localeData]').length > 0) {
			var locale = JSON.parse($('input[name=localeData]').val());
		}
		if ($('input[name=customerPageLoadData]').length > 0) {
			var customerPageLoadData = JSON.parse($('input[name=customerPageLoadData]').val());
		}
		if (pageLoad) {
			// overwrite fields that are part of customer data
			for (var key in customerPageLoadData) {
				pageLoad[key] = customerPageLoadData[key];
			}

			// add the banner image URL on the my account page
			var $accountBanner = $('.account-landing-slot .banner-content:visible');
			if ($accountBanner.length > 0) {
				var bannerImgStyle = $accountBanner.css('background-image');
				if (bannerImgStyle) {
					bannerImgStyle = bannerImgStyle.replace(/^url\("|"\)$/g, '');
				}
				pageLoad['re_account_header_img'] = bannerImgStyle || '';
			}

			pageLoad['event'] = 'pageLoad';
			dataLayer.push(pageLoad);
		}
	}
};
module.exports = storefront;
/* jshint ignore:end */
